import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "centents" }
const _hoisted_2 = { class: "heard" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "imgName" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  style: {"width":"5px"}
}
const _hoisted_7 = { class: "corpus" }
const _hoisted_8 = { class: "describe" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_divider = _resolveComponent("van-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.voiceControlArr, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "voiceContro",
          key: index
        }, [
          _createTextVNode(_toDisplayString(item.role) + " ", 1),
          (item.img)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/images/drawable-xxhdpi/' + item.img + '.png')
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _cache[0] || (_cache[0] = _createTextVNode(" :")),
          _createElementVNode("span", null, _toDisplayString(item.content), 1)
        ]))
      }), 128)),
      _createVNode(_component_van_divider)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"height":"230px"} }, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.conentArr, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "coentArr"
      }, [
        _createElementVNode("div", _hoisted_4, [
          (item.img && !$setup.hasChinese(item.img))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/images/drawable-xxhdpi/' + item.img + '.png')
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("span", _hoisted_6)),
          _createElementVNode("span", null, _toDisplayString(item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_7, "语料:" + _toDisplayString(item.corpus), 1),
        _createElementVNode("div", _hoisted_8, "描述:" + _toDisplayString(item.describe), 1)
      ]))
    }), 128))
  ]))
}